import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/components/AuthProvider";

import Index from "./pages/Index";
import About from "./pages/About";
import Membership from "./pages/Membership";
import Products from "./pages/Products";
import Tenders from "./pages/Tenders";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import NewsMedia from "./pages/NewsMedia";
import FAQ from "./pages/FAQ";
import Calculator from "./pages/Calculator";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import { MembershipApplication } from "./pages/MembershipApplication";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Sitemap from "./pages/Sitemap";
import VoiceAgentDashboard from "./pages/admin/VoiceAgentDashboard";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/membership-application" element={<MembershipApplication />} />
          <Route path="/products" element={<Products />} />
          <Route path="/tenders" element={<Tenders />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news-media" element={<NewsMedia />} />
          <Route path="/news" element={<NewsMedia />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/admin/voice-agent" element={<VoiceAgentDashboard />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
